import { Component, OnInit } from '@angular/core';
import { LoginService } from '@serengeti/serengeti-common';
import { DashboardWidgetContent, DashboardWidgetLookup } from '@serengeti/serengeti-dashboard';
import { UserService } from '@serengeti/serengeti-user';


@DashboardWidgetLookup('WizardUserInfoComponent')
@Component({
  selector: 'app-wizard-user-info',
  templateUrl: './wizard-user-info.component.html',
  styleUrls: ['./wizard-user-info.component.scss']
})
export class WizardUserInfoComponent implements OnInit, DashboardWidgetContent {

  userId;
  userName;
  userEmail;

  user = {
    description: '',
    email: '',
    groupId: '',
    groupName: '',
    locale: '',
    newPassword: '',
    password: '',
    quotas: '',
    reNewPassword: '',
    roles: '',
    status: '',
    userId: '',
    userIdHint: '',
    username: ''
  };

  imageSrc = '/assets/images/user/user.png' as any;
  defaultImageSrc = this.imageSrc;

  hasRoleRoot: boolean;
  hasRoleUserGeneral: boolean;
  hasRoleUserAdmin: boolean;

  constructor(
    private userService: UserService,
    private loginService: LoginService
  ) { }
  
  property(): boolean {
    return true;
  }

  configure(setting: any): void {
  }

  ngOnInit() {
    this.userService.get(this.loginService.getLoginId()).subscribe((user) => {
      this.user = user;

      this.doRefresh();
    });
  }

  doRefresh() {
    if (this.user) {
      this.userService.loadIcon(this.user.userId).subscribe(image => {
        if (image) {
          if (image.size !== 0) {
            const reader = new FileReader();
            const self = this;
  
            reader.onload = () => {
              self.imageSrc = reader.result;
            };
            reader.onerror = () => {
              self.imageSrc = this.defaultImageSrc;
            };
            reader.readAsDataURL(image);
          } else {
            this.imageSrc = this.defaultImageSrc;
          }
        }
      });
    }

    this.hasRoleRoot = this.loginService.hasRole('Root');
    this.hasRoleUserGeneral = this.loginService.hasRole('UserGeneral');
    this.hasRoleUserAdmin = this.loginService.hasRole('UserAdmin');
  }

}
